
<template>

  <group-container :title="element.label" :tooltip="element.describe">
    <template #title>
      {{element.label}}  <form-element-tooltip :element="element"></form-element-tooltip>
    </template>
    <el-tabs v-if="hasList" v-model="activeTab" style="margin-top: 10px">
      <el-tab-pane v-for="(item,index) in element.attrs.list" :key="index"
                   :name="String(index)" :label="tabLabel(item,index)">
        <el-table border style="width: 100%;border-radius: 6px;padding-bottom: 10px;margin-bottom: 20px"
                  :height="element.attrs.height"
                  :header-cell-style="{color:'#181A1D'}" @dragstart="e=>e.stopPropagation()">
          <el-table-column label="标题" v-if="item.showTitle"></el-table-column>
          <template v-for="(column,ci) in item.showColumns" :key="ci">
            <el-table-column :label="column.label"></el-table-column>
          </template>
        </el-table>
      </el-tab-pane>
    </el-tabs>
  </group-container>



</template>

<script>
import {mapStores} from "pinia";
import {useMenuStore} from "@/stores/menu";
import GroupContainer from "@/components/common/groupContainer.vue";
import FormElementTooltip from "@/components/common/formElementTooltip.vue";

export default {
  components: {FormElementTooltip, GroupContainer},
  props: {
    context: {
      type: Object,
      default: () => {
      }
    },
    element: {
      type: Object,
      default: () => {
      }
    },
    parent: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      data: this.element,
      activeTab: '0',
      formNameCache: {},  // formId -> 表单名称（用于 tab 标题）
    }
  },
  computed: {
    ...mapStores(useMenuStore),
    hasList() {
      return this.element.attrs && Array.isArray(this.element.attrs.list) && this.element.attrs.list.length > 0;
    }
  },
  created() {
    this.loadFormNames();
  },
  watch: {
    'element.attrs.list': {
      handler() {
        this.loadFormNames();
      },
      deep: true
    }
  },
  methods: {
    tabLabel(item, index) {
      return this.formNameCache[item.value] || `列表${index + 1}`;
    },
    loadFormNames() {
      (this.element.attrs.list || []).forEach(item => {
        if (item.value && !this.formNameCache[item.value]) {
          this.menuStore.findById(item.value).then(res => {
            if (res && res.data) {
              this.formNameCache[item.value] = res.data.name;
            }
          });
        }
      });
    }
  }


}
</script>

<style scoped lang="scss">

</style>
